const _TAG = `[<<] ndj_:`;

export async function ndj_fetch(
  url: string,
  payload: any,
  signal: AbortSignal,
  headers?: Record<string, string>,
): Promise<Response> {
  const opts = {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/x-ndjson',
      ...(headers || {}),
    },
    signal,
  };

  console.debug(`${_TAG} ndj_fetch:`, opts.headers, url);

  const res = await fetch(url, opts);
  if (!res.ok || !res.body) {
    throw new Error(`${_TAG} ndj_fetch request failed: ${res.status}`);
  }

  return res;
}

export async function* ndj_parse_stream(
  stream: ReadableStream<Uint8Array>,
  signal: AbortSignal,
  on_item?: (obj: any) => void,
): AsyncGenerator<any, void, unknown> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      if (signal?.aborted) {
        console.log('Stream processing aborted');
        throw new DOMException('Aborted', 'AbortError');
      }

      const { value, done } = await reader.read();
      if (done) {
        buffer += decoder.decode();
        break;
      }
      if (!value) {
        continue;
      }

      buffer += decoder.decode(value, { stream: true });

      const lastNL = buffer.lastIndexOf('\n');
      if (lastNL === -1) {
        continue;
      }

      const lines = buffer.slice(0, lastNL).split('\n');
      buffer = buffer.slice(lastNL + 1); // incomplete chunk. sohranyaem!

      for (const line of lines) {
        const obj = ndj_to_json(line);
        if (obj !== null) {
          on_item?.(obj);
          yield obj;
        }
      }
    }

    // NB! TAIL!
    if (buffer.trim()) {
      const obj = ndj_to_json(buffer.trim());
      if (obj !== null) {
        on_item?.(obj);
        yield obj;
      }
    }
  } finally {
    reader.releaseLock();
  }
}

function ndj_to_json(line: string): any {
  try {
    return JSON.parse(line);
  } catch {
    return null;
  }
}
